import { color, textColor } from "../theme";

type ColorKey = keyof typeof color;
type TextColorKey = keyof typeof textColor;
export type Color = ColorKey | TextColorKey;

export type SvgProps = {
  tint: Color;
  title?: string;
  strokeWidth?: string;
};

export function useColor(colorArgument: Color): string {
  if (isColor(colorArgument)) {
    return color[colorArgument];
  } else {
    return textColor[colorArgument];
  }
}

function isColor(value: any): value is ColorKey {
  return Object.keys(color).includes(value);
}
